import {Pipe, PipeTransform} from '@angular/core';
import {UnderfloorCurrentState} from "../models";
import {SubtitlesService} from "../core";

@Pipe({
    name: 'underfloorState'
})
export class UnderfloorStatePipe implements PipeTransform {
    constructor(
        private subtitles: SubtitlesService,
    ) {
    }

    transform(state: UnderfloorCurrentState): string {
        let stateString = '';

        if (state === 'waiting') {
            stateString = this.subtitles.setSubtitle(3162);
        } else if (state === 'alarm') {
            stateString = this.subtitles.setSubtitle(65);
        } else if (state === 'off') {
            stateString = this.subtitles.setSubtitle(924);
        } else if (state === 'floorTooCold') {
            stateString = this.subtitles.setSubtitle(4274);
        } else if (state === 'floorTooHot') {
            stateString = this.subtitles.setSubtitle(4275);
        } else if (state === 'parametersReached') {
            stateString = this.subtitles.setSubtitle(4276);
        } else if (state === 'antifreezeProtection') {
            stateString = this.subtitles.setSubtitle(4279);
        }

        return stateString;
    }
}
